let xrpdata = [
                {
                    "x": "2025-05-18T01:00:03.441Z",
                    "y": [
                        "2.56",
                        "2.56",
                        "2.56",
                        "2.56"
                    ]
                }
]

export default xrpdata